import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgetPasswordComponent } from './non-authenticated modules/forget-password/forget-password.component';
import { LoginComponent } from './non-authenticated modules/login/login.component';
import { AuthGuardGuard } from './services/auth-guard.guard';


const routes: Routes = [
  {path:"",redirectTo:"login", pathMatch:"full", },
  {path:"login",component:LoginComponent,data:{title:"Login"}},
  {path:"forgot",component:ForgetPasswordComponent,data:{title:"Forgot Password"}},
  {path:"home", loadChildren:() => import('../app/authenicated modules/modules/home/home.module').then((m => m.HomeModule)),canActivate: [AuthGuardGuard],}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
